import { AnalysisUseCase, Scope, Status } from 'generated/graphql';

export const INITIAL_ANALYSIS = {
  id: '',
  isLoading: false,
  tenantID: '',
  viewToken: '',
  editToken: '',
  scope: Scope.Private,
  panels: [],
  metadata: '{}',
  context: {
    eqlExpression: '',
  },
  isReportingDisabled: false,
  createdAt: Date.now(),
  createdBy: {
    firstName: '',
    lastName: '',
    id: '',
  },
  updatedAt: Date.now(),
  status: Status.Invalid,
  useCase: AnalysisUseCase.Default,
  isEditable: false,
  title: 'New Analysis',
  subtitle: '',
  href: '',
  path: '',
};
